module.exports = __webpack_public_path__ + "static/media/star-shop.109e8216.svg";